export function isAlphanumeric(str: string) {
    return /\D/.test(str); 
}

export function interpolateString(str: string, values: string[]) {
  return str.replace(/\$\{(\d+)\}/g, (match, index) =>
    values[index] !== undefined ? values[index] : match
  );
}

export function sanitizeString(str: string, allowedRegex: RegExp, maxLength: number) {
  const sanitized = str.replace(allowedRegex, '');

  return sanitized.slice(0, maxLength);
}